<div class="At-SettingsContent">
  <div class="At-InformationBox">
    <div class="At-Title">
      <h3>Messages</h3>
    </div>
    <ul class="At-InformationList">
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Notification Tone</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">Shandon</button>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Notification Preview</h5>
              <h6>Show previews of notifications at the top of the screen</h6>
            </div>
            <div class="At-TitleRight">
              <div class="At-SwitchCustom">
                <label class="switch">
                  <input type="checkbox" id="customSwitch1">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div class="At-InformationBox">
    <div class="At-Title">
      <h3>Calls</h3>
    </div>
    <ul class="At-InformationList">
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Ringtone</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">Felix</button>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Call Preview</h5>
              <h6>Show previews of incoming call at the top of tha screen</h6>
            </div>
            <div class="At-TitleRight">
              <div class="At-SwitchCustom">
                <label class="switch">
                  <input type="checkbox" id="customSwitch1">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div class="At-InformationBox">
    <div class="At-Title">
      <h3>Reset</h3>
    </div>
    <ul class="At-InformationList">
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Reset Notifications</h5>
              <h6>Undo all custom notification settings for all of your contact and channels.</h6>
            </div>
            <div class="At-TitleRight">
              <button type="button">Reset</button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
